import React, {useState, useCallback} from 'react';
import { useForm } from 'react-hook-form';
import { useMutation } from '@apollo/client';
import { ButtonGroup } from 'app/src/elements/buttons';
import { ButtonContainer, Button } from './elements';
import { View, Text } from 'react-native';
import { } from './queries';
import colors from '../../styles/colors';
import Input from 'app/src/elements/inputs';
import { UPDATE_BID } from './Bids/queries';

const paddleServices = [
  // {id: null, code: 'FL', name: 'Floor', color: colors.biddingFLBlue},
  {id: 1, code: 'PB', name: 'Proxibid', color: colors.biddingPBCyan},
  {id: 2, code: 'EF', name: 'Equipment Facts', color: colors.biddingEFTurquoise},
];

const WinnerInfoAlert = (props) => {
  const {highBidDetails, setShowModal} = props;
console.log('highBidDetails in winner', highBidDetails)
  const [updateBid] = useMutation(UPDATE_BID, {
    onCompleted: () => {
      props.setServiceEntered(true);
    }
  });

  const onSubmit = useCallback(input => {
    updateBid({ variables: input})
  });

  const {
    control, register, handleSubmit, watch, formState: { errors }
  } = useForm({
    defaultValues: {
      id: highBidDetails.id,
      paddleServiceId: parseInt(highBidDetails?.paddleService?.id),
      paddleNumber: ''
    }
  });

  return(
    <>
      <View style={{marginBottom: '20px'}}>
        <Text>It looks like the winning bid was on a different platform.</Text>
      </View>

      <Input.Picker
        label="Platform:"
        name="paddleServiceId"
        noPlaceholder
        options={paddleServices.map(service => {
          return { value: service.id, label: service.name }
        })}
        control={control}
        errors={errors}
      />

      <Input.Text
        label="Paddle Number:"
        name="paddleNumber"
        control={control}
        errors={errors}
        {...register("paddleNumber", {
          required: true,
        })}
      />
      <ButtonGroup style={{marginBottom: '20px'}}>
        <Button
          title="Cancel"
          color={colors.elRed}
          onPress={() => setShowModal(false)}
        />
        <Button
          title="Complete"
          color={colors.biddingAcceptGreen}
          onPress={handleSubmit(onSubmit)}
        />
      </ButtonGroup>

    </>
  )
}

export default WinnerInfoAlert;